import { render, staticRenderFns } from "./NewVehicle.vue?vue&type=template&id=77ff0196&scoped=true"
import script from "./NewVehicle.vue?vue&type=script&lang=js"
export * from "./NewVehicle.vue?vue&type=script&lang=js"
import style0 from "./NewVehicle.vue?vue&type=style&index=0&id=77ff0196&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ff0196",
  null
  
)

export default component.exports